export enum LocalStorage {
    accessToken = 'access_token',
    refreshToken = 'refresh_token',
    userMenu = 'user_menu',
    userApplicationModuleDetails = "user_application_module_details",
    loginData = 'loginData',
    applicationMenuId = 'applicationMenuId',
    applicationSubMenuId = 'applicationSubMenuId',
    companyDetailsId = 'companyDetailsId',
    companyName = 'companyName'
}